// extracted by mini-css-extract-plugin
export default {"googleButton":"SignInWithGoogleButton_googleButton__mLQwp","logo":"SignInWithGoogleButton_logo__ZrINe","label":"SignInWithGoogleButton_label__B4pP0"};